module.exports = __webpack_public_path__ + "media/images/avtar-54f484584d4d1e4afb46e245a96a7928.svg";